import angular from 'angular';
import { ITrabalhador } from '../../../../../Trabalhadores/models/trabalhador.model';
import { TrabalhadoresService } from '../../../../../Trabalhadores/trabalhadores.service';
import { applyNsjTableInlineMobileLabels, buildNsjTableInlineMobileLabel } from '../../../../../../utils/nsj-table';


export class MeurhEscalaColaboradoresFormModalController {

    static $inject = [
        '$scope',
        '$rootScope',
        '$uibModalInstance',
        'colaboradoresSelecionados',
        'TrabalhadoresService',
        'empresa',
        'estabelecimento',
    ];

    public entities: (ITrabalhador & { selected: boolean })[];
    public checkboxTodosColaboradores: boolean = false;
    public checkboxSelecionados: ITrabalhador[];
    public filtros: any = {
        lotacao: null,
        horario: null,
        search: null
    };

    public fields = applyNsjTableInlineMobileLabels([
        {
            value: 'selected',
            label: '',
            type: 'string',
            style: 'title',
            copy: '',
            customLabelHtml: buildNsjTableInlineMobileLabel('', { showOnMobile: false }),
            customCollumnScope: {
                verificaTodosCheckbox: (colaborador: ITrabalhador & { selected: boolean }) => {
                    this.checkboxSelecionados = this.checkboxSelecionados.filter(colab => colab.trabalhador !== colaborador.trabalhador);
                    if (colaborador.selected) {
                        this.checkboxSelecionados.push(colaborador);
                    }
                    this.setTodosColaboradoresCheckbox();
                },
            },
            customCollumnHtml: () => {
                let someHtmlVar = `
                    <div class="custom-checkbox text-center text-align-start-md">
                        <label>
                            <input
                                type="checkbox"
                                id="{{ tableRowEntity.trabalhador }}"
                                name="{{ tableRowEntity.trabalhador }}"
                                ng-value="tableRowEntity.trabalhador"
                                ng-model="tableRowEntity.selected"
                                ng-change="customCollumnScope.verificaTodosCheckbox(tableRowEntity)"
                            />
                            <span class="checkmark false"></span>
                        </label>
                    </div>
                `;
                return someHtmlVar;
            },
        },
        {
            value: 'nome',
            label: 'Nome',
            type: 'string',
            style: 'title',
            copy: '',
        },
        {
            value: 'cargo',
            label: 'Cargo',
            type: 'string',
            style: 'title',
            copy: '',
        },
        {
            value: 'lotacaoobj.nome',
            label: 'Lotação',
            type: 'string',
            style: 'title',
            copy: '',
        },
        {
            value: 'horario.nome',
            label: 'Horário',
            type: 'string',
            style: 'title',
            copy: '',
        },
    ]);

    constructor(
        public $scope: angular.IScope,
        public $rootScope: angular.IRootScopeService,
        public $uibModalInstance: ng.ui.bootstrap.IModalInstanceService,
        public colaboradoresSelecionados: ITrabalhador[],
        public TrabalhadoresService: TrabalhadoresService,
        public empresa: string,
        public estabelecimento: string
    ) {
        this.search();
        this.checkboxSelecionados = [...colaboradoresSelecionados];

        $scope.$on('persona_trabalhadores_list_loaded', (event, args: ITrabalhador[]) => {
            this.entities = this.setEntities(args);
            this.setTodosColaboradoresCheckbox();
        });
    }

    setEntities(args: ITrabalhador[]) {
        return args.map((colaborador) => {
            return {
                ...colaborador,
                selected: !!this.checkboxSelecionados.filter(colab => colab.trabalhador === colaborador.trabalhador).length
            };
        });
    }

    setEntitiesSelect(args: ITrabalhador[], selected: boolean) {
        const entities = args.map((colaborador) => {
            return {
                ...colaborador,
                selected
            };
        });

        if (selected) {
            const idsSelecionados = new Set(this.checkboxSelecionados.map(item => item.trabalhador));
            const novos = entities.filter(item => !idsSelecionados.has(item.trabalhador));
            this.checkboxSelecionados = [...this.checkboxSelecionados, ...novos];
        } else {
            const idsRemover = new Set(entities.map(item => item.trabalhador));
            this.checkboxSelecionados = this.checkboxSelecionados.filter(
                item => !idsRemover.has(item.trabalhador)
            );
        }

        return entities;
    }

    selecionaTodosColaboradores() {
        /* if (!this.TrabalhadoresService.loadParams.finished) {
            this.search(undefined, true)?.then(response => {
                this.entities = this.setEntitiesSelect(response, true);
            });
            return;
        } */
        this.entities = this.setEntitiesSelect(this.entities, this.checkboxTodosColaboradores);
    }

    setTodosColaboradoresCheckbox() {
        const hasEntity = this.entities.length; // && this.TrabalhadoresService.loadParams.finished;
        this.checkboxTodosColaboradores = hasEntity ? this.entities.every(colab => colab.selected) : false;
    }

    search(event?: angular.IAngularEvent & { detail: any }, loadAll?: boolean) {
        if (event) {
            this.filtros.search = event.detail.search;
        }
        const constructor = {
            empresa: this.empresa,
            estabelecimento: this.estabelecimento,
            ...(this.filtros.lotacao && {
                lotacao: this.filtros.lotacao.lotacao
            }),
            ...(this.filtros.horario && {
                horario: this.filtros.horario.horario
            }),
            status: '00'
        };
        this.TrabalhadoresService.constructors = constructor;
        if (loadAll) {
            return this.TrabalhadoresService.loadNoPagination({ ...constructor, filter: this.filtros.search });
        }
        this.TrabalhadoresService.search({ search: this.filtros.search });
    }

    loadMore() {
        this.TrabalhadoresService.loadMore();
    }

    close() {
        this.$uibModalInstance.dismiss('fechar');
    }

    submit() {
        this.$uibModalInstance.close(this.checkboxSelecionados);
    }
}
